module.exports = __webpack_public_path__ + "static/spotify-4fc55d1d7ce57d9c803f7b702b4d3875.png";